import { Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { PostDataFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

import TotalVisits from 'modules/posts/components/Visits/TotalVisits'
import VisitList from 'modules/posts/components/Visits/VisitList'

interface Props {
  post: PostDataFragment
  withText?: boolean
  canSeeVisits: boolean
}

function Visits({ post, withText, canSeeVisits }: Props) {
  const [open, toggle] = useToggle(false)

  const postVisits = post.visits.edges.flatMap((edge) => edge.node) ?? []
  const visitsCount = useMemo(() => {
    if (post.visits.totalCount) {
      return post.visits.totalCount
    } else {
      return 0
    }
  }, [post.id])

  const canBeShown = visitsCount > 0 && canSeeVisits

  return (
    <Tooltip.ItemList
      title={i18n.t('dashboard.visits.title')}
      attachment="bottom center"
      open={canBeShown && open}
      toggle={toggle}
    >
      <TotalVisits withText={withText} visits={post.visits?.totalCount ?? 0} />
      <VisitList visits={postVisits} />
    </Tooltip.ItemList>
  )
}

export default observer(Visits)
